<template>

  <ContentsProductHighPerformancePageTitle title="LCP (Liquid Crystal Polymer)" />

  <section class="section-product-detail-page" >
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/high-performance-plastics/lcp01.jpg"
            :contents="[
              `LCP is high flow. Extremely good weatherability
              and chemical resistance. Very good in dimension, low moisture absorption and can have HDT up to 250c.
              outstanding strength in extreme temperatures`,
            ]"
            :is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/high-performance-plastics/lcp02.jpg"
            :contents="[
              `High strength and lightweight applications like
              wire and cables,sport equipment. Thin wall parts like complex shape connectors and electrical components
              as well as application that exposed to extreme temperatures, chemicals microelectromechanical systems
              (MEMS), Electrical parts microwave frequency application due to low dk, low df.`,
            ]"
            :is-content-small-text="true"
            left-width="45.869%"
            right-width="53.827%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :partners="[
            {
              name: 'Polyplastics',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-poly.jpg',
              },
            },
            {
              name: 'Toray',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-torry.jpg',
              },
            },
            {
              name: 'Celanese',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-calane.jpg',
              },
            },
            {
              name: 'RTP',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo03.jpg',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title: 'lcp - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>
